// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.byk-login {
  background-color: #003cff;
  display: flex;
  flex-flow: column wrap;
  height: 100vh;
  width: 100vw;
}

.byk-logo {
  max-width: 400px;
}

.byk-title {
  font-size: 22px;
  color: #fff;
  margin: 0 0 20px 0;
}

.byk-login-form {
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  margin-bottom: 1rem;
  justify-content: center;
}

.login {
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  justify-content: center;
}

.login-button {
  min-width: 200px;
}

.footer {
  align-items: center;
  background-color: #fff;
  display: flex;
  justify-content: center;
  padding: 16px 0;
}`, "",{"version":3,"sources":["webpack://./src/views/password-login.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,wBAAA;EACA,YAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AACF","sourcesContent":[".byk-login {\n  background-color: #003cff;\n  display: flex;\n  flex-flow: column wrap;\n  height: 100vh;\n  width: 100vw;\n}\n\n.byk-logo {\n  max-width: 400px;\n}\n\n.byk-title {\n  font-size: 22px;\n  color: #fff;\n  margin: 0 0 20px 0;\n}\n\n.byk-login-form {\n  align-items: center;\n  display: flex;\n  flex-flow: column nowrap;\n  flex-grow: 1;\n  margin-bottom: 1rem;\n  justify-content: center;\n}\n\n.login {\n  align-items: center;\n  display: flex;\n  flex-flow: column nowrap;\n  flex-grow: 1;\n  justify-content: center;\n}\n\n.login-button {\n  min-width: 200px;\n}\n\n.footer {\n  align-items: center;\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  padding: 16px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
